class FeedbackQueue {
    /**
     * Constructor
     * @param {String} id Queue ID
     * @param {Function} callback Function attached to all the items in the queue
     */
    constructor(id, callback) {
        this.id = id
        this.callback = callback
        this.queue = []
    }

    push(item) {
        this.queue.push(item)
    }

    call() {
        if (this.callback instanceof Function) {
            this.callback(this.id, this.queue)
        }
    }
}

export default FeedbackQueue
